/**
 * @generated SignedSource<<f69524f99dc95666efa9a517d252e3bd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileTooltip_viewer$data = {
  readonly nftBenignNeglect: boolean | null;
  readonly " $fragmentType": "NftItemTileTooltip_viewer";
};
export type NftItemTileTooltip_viewer$key = {
  readonly " $data"?: NftItemTileTooltip_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileTooltip_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileTooltip_viewer",
  "selections": [
    {
      "alias": "nftBenignNeglect",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftBenignNeglect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "32ea1567296c328676ce8ae1aa73e9e0";

export default node;
